import { Grid } from '@rsa-digital/evo-shared-components/components/Grid';
import React, { MouseEventHandler } from 'react';
import { Body, Heading, HeadingGrid, PaddedGridItem, StyledModal } from './styles';

type ConfirmationModalProps = {
  title: string;
  body: string;
  onClose: MouseEventHandler;
};

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  title,
  body,
  onClose,
}) => (
  <StyledModal onClose={onClose} data-cy="ConfirmationModal">
    <HeadingGrid>
      <PaddedGridItem desktop={4} tabletLandscape={4} tabletPortrait={4}>
        <Heading>{title}</Heading>
      </PaddedGridItem>
    </HeadingGrid>
    <Grid>
      <PaddedGridItem desktop={8} tabletLandscape={8} tabletPortrait={6}>
        <Body>{body}</Body>
      </PaddedGridItem>
    </Grid>
  </StyledModal>
);

export default ConfirmationModal;
